import Learn from 'components/learn/Learn.jsx'
import React from "react";
import clientPromise from "../../lib/mddb.mjs";
import computeFields from "../../lib/computeFields";
import fs from "fs"

export default function LearnPage({blogs}){
  return(  
    <Learn blogs={blogs}/>
  )

}

export async function getStaticProps() {
  const mddb = await clientPromise;
  const blogFiles = await mddb.getFiles({ folder: "blog" });
  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);

  return {
    props: {
      meta: {
        title: "Learn",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
        description: "Learn more about CKAN, Datopian tech and Datopian culture."
      },
      blogs: blogsList,
    },
  };
};
